<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('client_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/setting/user-create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="view_type=0" :class="{active:view_type==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="view_type=1" :class="{active:view_type==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                    <th>{{ $t('name') }}</th>
                                    <th>{{ $t('email') }}</th>
                                    <th style="width: 10px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in records" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td><router-link :to="{ name: 'client_edit', params: { id: ret.Id } }">{{ret.Name}}</router-link></td>
                                    <td>{{ret.Email}}</td>
                                    <td class="table-cell">
                                        <!--<button type="button" class="btn btn-danger btn-table-xs" @click="onReset(ret)"><i class="fa fa-key" aria-hidden="true"></i></button>-->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                      hide-goto-end-buttons
                                      @change="paging($event)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        data: function () {
            return {
                query: {
                    Text: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25
                },
                records: [],
                view_type: 0
            }
        },
        created: function () {
            this.toList();
        },
        methods: {
            toList: function () {
                let loading = this.$loading.show();
                this.$api().post('client/list', this.query).then((res) => {
                    if (this.$isValid(res)) {
                        const data = res.data;
                        this.records = data.Json.Clients;
                        this.query.Total = data.Total;
                    }
                }).finally(() => { loading.hide(); });
            },
            paging(e) {
                this.query.Page = e;
                this.toList();
            }
        }
    }
</script>
